import { render } from "./Navigation.vue?vue&type=template&id=739d49e0&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=739d49e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-739d49e0"],['__file',"src/js/components/Navigation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "739d49e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('739d49e0', __exports__)) {
    api.reload('739d49e0', __exports__)
  }
  
  module.hot.accept("./Navigation.vue?vue&type=template&id=739d49e0&scoped=true", () => {
    api.rerender('739d49e0', render)
  })

}


export default __exports__